import produce from 'immer';

import { createCreator, createReducer, Reducer } from '~/helpers/util/reducers';
import { CreateInit } from '../../_core/specialDates/duck';

export type CreateStatus = 'idle' | 'creating' | 'success' | 'failure';

export type SpecialDateCreateState = {
  createStatus: CreateStatus;
  errorMessage?: string;
};

export type CreateError = {
  errorMessage?: string;
};

export const initialState: SpecialDateCreateState = {
  createStatus: 'idle'
};

const prefix = '@specialDateCreate';

export const Types = Object.freeze({
  CLEAR: `${prefix}/CLEAR`,
  CREATE_INIT: `${prefix}/CREATE_INIT`,
  CREATE_SUCCESS: `${prefix}/CREATE_SUCCESS`,
  CREATE_FAILURE: `${prefix}/CREATE_FAILURE`
});

const clearReducer: Reducer<SpecialDateCreateState, void> = state => {
  return produce(state, draft => {
    draft.createStatus = initialState.createStatus;
  });
};

const createInitReducer: Reducer<SpecialDateCreateState, void> = state => {
  return produce(state, draft => {
    draft.createStatus = 'creating';
  });
};

const createSuccessReducer: Reducer<SpecialDateCreateState, void> = state => {
  return produce(state, draft => {
    draft.createStatus = 'success';
  });
};

const createFailureReducer: Reducer<SpecialDateCreateState, CreateError> = (
  state,
  action
) => {
  return produce(state, draft => {
    draft.createStatus = 'failure';
    draft.errorMessage = action.errorMessage;
  });
};

export const actions = Object.freeze({
  clear: createCreator<void>(Types.CLEAR),
  createInit: createCreator<CreateInit>(Types.CREATE_INIT),
  createSuccess: createCreator<void>(Types.CREATE_SUCCESS),
  createFailure: createCreator<CreateError>(Types.CREATE_FAILURE)
});

export const reducer = createReducer(initialState, {
  [Types.CLEAR]: clearReducer,
  [Types.CREATE_INIT]: createInitReducer,
  [Types.CREATE_SUCCESS]: createSuccessReducer,
  [Types.CREATE_FAILURE]: createFailureReducer
});
